// Gravity Forms ververst zijn markup bij elke pagina (AJAX), dus alles wordt bij elke render opnieuw gelezen en de luisteraars hangen aan de wortel.
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

const initTool = (root) => {
	const back = root.querySelector(".keuzehulp-back");
	const progressBar = root.querySelector('[role="progressbar"]');
	const segments = root.querySelectorAll(".pk-keuzehulp-shell-segment");
	const live = root.querySelector(".pk-keuzehulp-shell-live");
	const total = parseInt(root.dataset.pages, 10) || 1;
	let lastPage = 0;

	const visiblePage = () => {
		const pages = [...root.querySelectorAll(".gform_page")];
		const page = pages.find((el) => getComputedStyle(el).display !== "none");
		return { page, number: page ? pages.indexOf(page) + 1 : 1, count: pages.length || total };
	};

	// "Scenario A: tekst" wordt kop (woord en letter) plus tekst; de tekst staat daarna niet meer dubbel in de label.
	const splitScenarios = () => {
		root.querySelectorAll(".keuzehulp-scenario .gchoice label:not([data-split])").forEach((label) => {
			label.dataset.split = "";
			const match = label.textContent.trim().match(/^(\S+)\s+(\S+?):\s*([\s\S]+)$/);
			if (!match) return;

			const head = document.createElement("span");
			head.className = "scenario-head";
			const badge = document.createElement("span");
			badge.className = "scenario-badge";
			badge.textContent = match[2];
			head.replaceChildren(document.createTextNode(match[1]), badge);

			const text = document.createElement("span");
			text.className = "scenario-text";
			text.textContent = match[3];

			label.replaceChildren(head, text);
		});
	};

	const orderInput = (field) => field.closest(".gform_page")?.querySelector(".keuzehulp-rank-order input");
	const readOrder = (field) => (orderInput(field)?.value || "").split(",").map((value) => value.trim()).filter(Boolean);
	// De volgorde bewaart het nummer van de keuze (1, 2 ...), niet de waarde: een waarde kan zelf komma's bevatten (engineering:1,sheq:1).
	const choiceNumber = (field, input) => String([...field.querySelectorAll(".gchoice input")].indexOf(input) + 1);

	// Bij elke render opnieuw: de volgorde komt uit het verborgen veld, dus ook na terugbladeren kloppen de plekken.
	const renderBadges = () => {
		root.querySelectorAll(".keuzehulp-rank").forEach((field) => {
			const order = readOrder(field);
			const choices = [...field.querySelectorAll(".gchoice")];

			choices.forEach((choice) => {
				const input = choice.querySelector("input");
				let badge = choice.querySelector(".rank-badge");
				const position = input.checked ? order.indexOf(choiceNumber(field, input)) + 1 : 0;

				if (!position) return badge?.remove();

				if (!badge) {
					badge = document.createElement("span");
					badge.className = "rank-badge";
					badge.setAttribute("aria-hidden", "true");
					choice.append(badge);
				}
				badge.textContent = String(position).padStart(2, "0");
			});

			// Twee kolommen onder elkaar gevuld: de linkerhelft eerst.
			field.querySelector(".gfield_checkbox")?.style.setProperty("--rows", Math.ceil(choices.length / 2));
		});
	};

	const sync = () => {
		const { page, number, count } = visiblePage();

		root.classList.toggle("is-wide", !!page?.querySelector(".keuzehulp-wide"));

		// Eén balk per vraag: de balken tot en met de huidige vraag zijn vol, de rest leeg.
		segments.forEach((segment, index) => segment.style.setProperty("--fill", index < number ? 1 : 0));
		progressBar?.setAttribute("aria-valuenow", Math.round((number / count) * 100));

		if (live && live.dataset.template) {
			live.textContent = live.dataset.template.replace("{x}", number).replace("{y}", count);
		}

		// De terugknop gaat naar de start en staat alleen op de eerste vraag, voor de volgende-knop.
		if (back) {
			const footer = page?.querySelector(".gform_page_footer");
			const next = footer?.querySelector(".gform_next_button");
			const show = number === 1 && !!footer;

			back.hidden = !show;
			if (show && back.parentNode !== footer) footer.insertBefore(back, next || null);
		}

		splitScenarios();
		renderBadges();

		// Na een paginawissel naar de vraag, zodat toetsenbord en schermlezer niet in de oude knop blijven staan.
		if (lastPage && number !== lastPage) {
			const label = page?.querySelector(".gfield_label");
			if (label) {
				label.setAttribute("tabindex", "-1");
				label.focus({ preventScroll: reduceMotion.matches });
			}
		}
		lastPage = number;
	};

	root.addEventListener("change", (event) => {
		const input = event.target;
		if (!input.matches(".keuzehulp-rank input[type=checkbox]")) return;

		const field = input.closest(".keuzehulp-rank");
		const hidden = orderInput(field);
		if (hidden) {
			const number = choiceNumber(field, input);
			const order = readOrder(field).filter((value) => value !== number);
			if (input.checked) order.push(number);
			hidden.value = order.join(",");
		}

		renderBadges();
	});

	// Gravity Forms vuurt deze events via jQuery; jQuery kan na deze module laden, dus wacht tot hij er is.
	const bind = () => {
		const $ = window.jQuery;
		if (!$) return false;

		$(document).on("gform_post_render gform_page_loaded", sync);
		return true;
	};

	if (!bind()) window.addEventListener("load", bind, { once: true });

	sync();
};

document.querySelectorAll(".keuzehulp_tool-layout").forEach(initTool);
